var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "CustomerList",
      "extra-items": ['顧客會員批次上傳']
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "col-12 col-xl-6 d-flex align-items-center"
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("顧客會員批次上傳")])]), _c('div', {
    staticClass: "row my-3"
  }, [_c('div', {
    staticClass: "col-12 col-xl-3"
  }, [_c('div', [_vm._v("請選擇通路")]), _c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.isFetchMerchants
    },
    model: {
      value: _vm.selectedMerchantID,
      callback: function callback($$v) {
        _vm.selectedMerchantID = $$v;
      },
      expression: "selectedMerchantID"
    }
  }), _c('div', [_vm._v("上傳設定資料設定：")]), _c('b-form-checkbox', {
    model: {
      value: _vm.isMobileSettingVerified,
      callback: function callback($$v) {
        _vm.isMobileSettingVerified = $$v;
      },
      expression: "isMobileSettingVerified"
    }
  }, [_c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      value: '有手機資料，才會設定已驗證',
      expression: "'有手機資料，才會設定已驗證'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "d-inline-flex align-items-center"
  }, [_vm._v("手機設定已驗證 "), _c('span', {
    staticClass: "mdi mdi-help-circle-outline ml-1"
  })])]), _c('b-form-checkbox', {
    model: {
      value: _vm.isRegistered,
      callback: function callback($$v) {
        _vm.isRegistered = $$v;
      },
      expression: "isRegistered"
    }
  }, [_vm._v(" 設定已註冊 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-3 offset-1 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("請選擇會員識別欄位")]), _vm._l(_vm.uniqueByList, function (unique_by) {
    return _c('b-form-checkbox', {
      key: unique_by.id,
      staticClass: "mr-2",
      attrs: {
        "value": unique_by.id
      },
      model: {
        value: _vm.form.unique_by,
        callback: function callback($$v) {
          _vm.$set(_vm.form, "unique_by", $$v);
        },
        expression: "form.unique_by"
      }
    }, [_vm._v(" " + _vm._s(unique_by.name) + " ")]);
  })], 2)]), _c('div', {
    staticClass: "\n          col-12 col-xl-4\n          d-flex\n          flex-column\n          align-items-start align-items-xl-center\n        "
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.getSampleExcelFile(_vm.getModuleConfig('customer', 'sample_file.customer_import_xls'), '/excel/customer_list.xlsx');
      }
    }
  }, [_vm._v("下載範例檔案")]), _c('div', {
    staticClass: "row mt-2"
  }, [_c('b-form-file', {
    key: _vm.fileInputKey,
    attrs: {
      "id": "fileInput",
      "plain": "",
      "hidden": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": _vm.handleUploadFile
    }
  }), _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary",
      "tag": "label",
      "for": "fileInput"
    }
  }, [_vm._v(" 請選擇檔案")])], 1), _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSubmitFile
    }
  }, [_vm._v("確定上傳")]), _vm.results.failed.length > 0 ? _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.exportFailedCustomers
    }
  }, [_vm._v("下載失敗檔案")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "accordion",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l(Object.keys(_vm.results), function (key, index) {
    return _c('b-card', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "no-body": ""
      }
    }, [_c('b-card-header', {
      staticClass: "p-1",
      attrs: {
        "header-tag": "header",
        "role": "tab"
      }
    }, [key === 'failed' ? _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle.accordion-0",
        modifiers: {
          "accordion-0": true
        }
      }],
      attrs: {
        "block": "",
        "variant": "info"
      }
    }, [_vm._v("失敗：" + _vm._s(_vm.results.failed.length) + "筆")]) : _vm._e(), key === 'created' ? _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle.accordion-1",
        modifiers: {
          "accordion-1": true
        }
      }],
      attrs: {
        "block": "",
        "variant": "info"
      }
    }, [_vm._v("新增：" + _vm._s(_vm.results.created.length) + "筆")]) : _vm._e(), key === 'existed' ? _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle.accordion-2",
        modifiers: {
          "accordion-2": true
        }
      }],
      attrs: {
        "block": "",
        "variant": "info"
      }
    }, [_vm._v("更新：" + _vm._s(_vm.results.existed.length) + "筆")]) : _vm._e()], 1), _c('b-collapse', {
      attrs: {
        "id": "accordion-".concat(index),
        "visible": "",
        "accordion": "my-accordion",
        "role": "tabpanel"
      }
    }, [_c('b-card-body', [_c('b-table', {
      attrs: {
        "striped": "",
        "hover": "",
        "responsive": "",
        "items": _vm.results[key],
        "fields": _vm.tableFields(key),
        "busy": _vm.isLoading
      },
      scopedSlots: _vm._u([{
        key: "table-busy",
        fn: function fn() {
          return [_c('div', {
            staticClass: "text-center my-2"
          }, [_c('b-spinner', {
            staticClass: "align-middle"
          })], 1)];
        },
        proxy: true
      }], null, true)
    })], 1)], 1)], 1);
  }), 1)])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }